import { Switch as HeadlessUISwitch } from '@headlessui/react';
import classNames from 'classnames';

export interface SelectOption {
  name?: string;
  value?: string;
}

interface Props {
  checked: boolean;
  onChange: (checked: boolean) => void;
}

const Switch = ({ checked, onChange }: Props) => {
  return (
    <HeadlessUISwitch
      checked={checked}
      onChange={onChange}
      className={classNames(
        'relative inline-flex h-6 w-11 items-center rounded-full',
        checked ? 'bg-[#111827]' : 'bg-[#E5E7EB]',
      )}
    >
      <span className="sr-only">Enable</span>
      <span
        className={classNames(
          'inline-block h-5 w-5 transform rounded-full bg-white transition',
          checked ? 'translate-x-[22px]' : 'translate-x-[2px]',
        )}
      />
    </HeadlessUISwitch>
  );
};

export default Switch;
